import { Tab } from '@app/shared/components/tabs/tab.interface';
import { BuildingAuthorityType } from '@app/shared/models/building-authority-type';
import { SecurityUtils } from '@app/shared/utils/security.utils';


export const driverMetricsTabs: Tab[] = [
  {
    name: 'Timeseries',
    path: '/buildings/{buildingId}/driver-metrics/timeseries',
    dataCy: 'driver-metrics-timeseries-tab',
    isAuthorized: SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.VIEW_ADM_INSIGHTS)
  },
  {
    name: 'Static',
    path: '/buildings/{buildingId}/driver-metrics/static',
    dataCy: 'driver-metrics-static-tab',
    isAuthorized: SecurityUtils.hasBuildingAuthority(BuildingAuthorityType.VIEW_ADM_INSIGHTS)
  }
];
